import { z } from "zod";
import { createLocalStore } from "../../../lib/store";

const HISTORY_LIMIT = 10;

const useStore = createLocalStore<string[]>(
  "search-history",
  [],
  z.array(z.string().min(1)).max(HISTORY_LIMIT)
);

export function useSearchHistory(): {
  history: string[];
  addEntry: (value: string) => void;
  removeEntry: (value: string) => void;
  clear: () => void;
} {
  const [history, setHistory] = useStore();

  return {
    history,
    addEntry(value) {
      const trimmed = value.trim();
      if (trimmed.length === 0) return;
      setHistory((prev) => {
        const without = prev.filter((entry) => entry !== trimmed);
        return [trimmed, ...without].slice(0, HISTORY_LIMIT);
      });
    },
    removeEntry(value) {
      setHistory((prev) => prev.filter((entry) => entry !== value));
    },
    clear() {
      setHistory([]);
    },
  };
}
